var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnicode = function SvgUnicode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "unicode_svg2__a",
    x1: 33.5,
    x2: 172.42,
    y1: 174.2,
    y2: 19.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M170 0H30C13.43 0 0 13.43 0 30v140c0 16.57 13.43 30 30 30h140c16.57 0 30-13.43 30-30V30c0-16.57-13.43-30-30-30m-1.64 150q0 1.17-1.17 1.17h-19.14c-10.74-18.3-21.16-36.8-31.25-55.47a242 242 0 0 1-9.77-19.53v37.5c0 7.03-1.17 12.89-3.12 17.97s-5.08 8.98-8.2 12.11c-3.52 3.12-7.81 5.47-12.5 7.03a53.9 53.9 0 0 1-31.64-.39 30.46 30.46 0 0 1-19.92-18.75c-1.95-4.69-2.73-10.55-2.73-16.8V54.68c0-.78.39-1.56 1.17-1.56h15.62q1.17 0 1.17 1.17v58.98c0 7.03 1.95 12.89 5.47 17.19s8.59 6.25 16.02 6.25l8.2-1.17c2.34-.78 4.69-1.95 6.25-3.91 1.95-1.95 3.12-4.69 4.3-7.42s1.56-6.64 1.56-11.33V54.29q0-1.17 1.17-1.17h21.09l1.17.39.78.78 6.25 11.33 7.42 14.06 7.81 14.45 7.42 13.67 6.25 11.72 3.91 7.81v-3.52c-.34-6.5-.47-13.02-.39-19.53V78.89q0-1.17 1.17-1.17h14.45c.78 0 1.17.39 1.17 1.56v70.7Zm-8.2-82.42c-5.61 0-10.16-4.55-10.16-10.16s4.55-10.16 10.16-10.16 10.16 4.55 10.16 10.16-4.55 10.16-10.16 10.16",
    style: {
      fill: "url(#unicode_svg2__a)",
      strokeWidth: 0
    }
  }));
};
export default SvgUnicode;